import { Loader } from "lucide-react";
import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";

import { SuggestedLocalPostItem } from "../../../../components/DashboardComponents/LocalPostsComponent/SuggestedLocalPostItem";
import { InfiniteScroller } from "../../../../components/InfiniteScroller";
import { LocationData } from "../../../../models/LocationData";
import { SuggestedLocalPostData } from "../../../../models/SuggestedLocalPostData";
import { useSuggestedLocalPosts } from "../../hooks/useSuggestedLocalPosts";
import "./styles.scss";

interface ISuggestedPostsCardProps {
  locationId: string;
  locationData?: LocationData;
}

export const SuggestedPostsCard: React.FC<ISuggestedPostsCardProps> = ({
  locationId,
  locationData,
}) => {
  const { t: _t } = useTranslation();
  const t = (key: string) => _t(`facilityDetailsPage.keywordAnalysis.${key}`);

  const { fetchSuggestedPosts } = useSuggestedLocalPosts();

  const renderSuggestedItem = useCallback(
    (item: SuggestedLocalPostData) => (
      <SuggestedLocalPostItem
        key={item.id}
        postItem={item}
        locationData={locationData}
      />
    ),
    [locationData]
  );

  return (
    <div className="white-border-panel suggested-posts-section">
      <h3 className="section-title">{t("suggestedPost")}</h3>
      <div className="suggested-posts-scroller-wrapper">
        <InfiniteScroller<
          SuggestedLocalPostData,
          { locationId: string; order: string; sort: string }
        >
          fetchFunction={fetchSuggestedPosts}
          initialParams={{
            locationId,
            order: "desc",
            sort: "created_at",
          }}
          pageSize={10}
          dependencyKey={locationId}
          renderItem={renderSuggestedItem}
          direction="horizontal"
          className="suggested-posts-horizontal-scroller"
          loadingComponent={
            <div className="scroller-loading-indicator">
              <Loader className="animate-spin text-blue" size={24} />
            </div>
          }
          noItemsComponent={
            <div className="scroller-no-items">{t("noSuggestedPosts")}</div>
          }
        />
      </div>
    </div>
  );
};
export default SuggestedPostsCard;
